import React from 'react';

import { PricesFixed, PricesCategorySection, PricePerDay,FuturePrices } from 'components';

import { useStyles } from 'components/prices-create/styles';

const AccommodationPricesCreate = ({
  selectedTabIndex,
  onSubmit,
  setSubmitButton,
  isUpdate,
}) => {
  const classes = useStyles();

  const PRICES = {
    fixedPrices: 0,
    categoryPrices: 1,
    dailyPrices: 2,
  };


  return (
    <div className={classes.wrapper}>
      {selectedTabIndex === PRICES.fixedPrices && (
        <PricesFixed
          onSubmit={values => onSubmit(values, 'pricesFixedForm')}
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      )}
      {selectedTabIndex === PRICES.categoryPrices && (
        <PricesCategorySection
          onSubmit={values => onSubmit(values, 'pricesCategoryForm')}
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      )}
      {selectedTabIndex === PRICES.dailyPrices && (
        <PricePerDay
          onSubmit={values => onSubmit(values, 'pricesDailyForm')}
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      )}
    </div>
  );
};

export default AccommodationPricesCreate;
